export enum PreferenceKey {
  Category = "category",
  Subcategory = "subcategory",
  Sizes = "sizes",
  Length = "length",
}

export const TAGS_ANIMATION_DURATION = 200;

export const PRIMARY_ATTRIBUTE_DRAWER_STYLES = {
  boxShadow: "none",
  border: "none",
  backgroundColor: "rgba(245, 245, 250, 0.4)",
  backdropFilter: "blur(18px)",
};

export const DRAWER_STYLES = {
  boxShadow: "none",
  border: "none",
  backgroundColor: "rgba(255, 255, 255, 0.92)",
  backdropFilter: "blur(20px)",
};
